import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  useOutsideClick,
  Flex,
  Box,
  useDisclosure,
  Badge,
  Icon,
  InputGroup,
  InputLeftElement,
  Input,
  Text,
} from '@chakra-ui/react';
import { debounce } from 'lodash-es';
import SearchIcon from '@/icons/Search';
import { CheckIcon } from '@heroicons/react/solid';
import { Tag, TagLabel, TagLeftIcon } from '@chakra-ui/react';
import { useState, useRef, useEffect } from 'react';
import JobTitleIcon from '@/icons/JobTitle';

export const DepartmentFilter = ({
  departments = [],
  filter = {},
  onSelect = () => {},
}) => {
  const [selected, setSelected] = useState(filter?.departments);
  const [options, setOptions] = useState(departments);
  const { onClose, isOpen, onToggle } = useDisclosure();
  const ref = useRef(null);
  const inputRef = useRef(null);

  const onChange = debounce(() => {
    const updatedOptions = departments?.filter((department) => {
      return department?.key
        ?.toLocaleLowerCase()
        ?.includes(inputRef?.current?.value);
    });
    setOptions(updatedOptions);
  }, 300);

  const onClick = (selectedDepartment) => {
    setSelected(selectedDepartment);
    onSelect(selectedDepartment);
    onClose();
  };

  useEffect(() => {
    setSelected(filter?.department);
  }, [filter]);

  useOutsideClick({
    ref: ref,
    handler: () => onClose(),
  });

  return (
    <Box ref={ref} ml="12px">
      <Popover placement="bottom-start" isOpen={isOpen}>
        <PopoverTrigger>
          <Tag
            height="40px"
            bg={isOpen ? '#F6F7F8' : '#FFF'}
            borderRadius="full"
            borderWidth="1px"
            borderColor="light.border"
            _hover={{ background: '#F6F7F8' }}
            cursor="pointer"
            px="16px"
            onClick={onToggle}
          >
            <TagLeftIcon
              as={JobTitleIcon}
              set="bold"
              width="16px"
              height="16px"
              color="#4833CE"
            />
            <TagLabel fontSize="sm" fontWeight="semiBold">
              Departments
              {selected && (
                <Badge
                  width="20px"
                  height="20px"
                  bg="#131415"
                  color="white"
                  textAlign="center"
                  pt="2px"
                  pl="4px"
                  ml="4px"
                  borderRadius="50%"
                >
                  1
                </Badge>
              )}
            </TagLabel>
          </Tag>
        </PopoverTrigger>

        <PopoverContent width="350px">
          <PopoverBody padding="lg">
            {departments?.length > 5 && (
              <Box>
                <InputGroup>
                  <InputLeftElement
                    pointerEvents="none"
                    children={<SearchIcon />}
                  />
                  <Input
                    placeholder="Search Location"
                    ref={inputRef}
                    onChange={onChange}
                  />
                </InputGroup>
              </Box>
            )}

            <Box minH="30px" maxH="200px" overflow="auto">
              {options?.map((department) => {
                const isSelected = department?.key === selected;
                return (
                  <Flex
                    key={department?.key}
                    alignItems="center"
                    px="8px"
                    borderRadius="8px"
                    _hover={{ bg: 'light.hover' }}
                  >
                    <Box
                      flex="1"
                      py="12px"
                      px="sm"
                      fontSize="14px"
                      fontWeight={isSelected ? 600 : 400}
                      color={isSelected ? '#0043CE' : '#121314'}
                      _hover={{ bg: 'light.hover', borderRadius: '5px' }}
                      cursor="pointer"
                      borderRadius="sm"
                      onClick={() => onClick(department)}
                      textTransform="capitalize"
                    >
                      {department.key}
                    </Box>
                    {isSelected && <Icon as={CheckIcon} color="#0043CE" />}
                  </Flex>
                );
              })}
              {options.length === 0 && (
                <Box textAlign="center">
                  <Text variant="muted">No Option found</Text>
                </Box>
              )}
            </Box>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
};
